// Deprecated: Auth0 support has been removed. This hook is kept only to avoid breaking imports.
// It always returns undefined.
export default function useGetAuth0Client(): undefined {
	return undefined;
}
